/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { HolidayCalendarModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class HolidayCalendarsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags HolidayCalendars
   * @name HolidayCalendarsGet
   * @summary Retrieves the Holiday calendar dates.
   * @request GET:/holidayCalendars
   */
  holidayCalendarsGet = (params: RequestParams = {}) =>
    this.http.request<HolidayCalendarModelDto[], any>({
      path: `/holidayCalendars`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags HolidayCalendars
   * @name HolidayCalendarsPost
   * @summary Save the passed Holiday Calendar.
   * @request POST:/holidayCalendars
   */
  holidayCalendarsPost = (
    data: HolidayCalendarModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<HolidayCalendarModelDto, any>({
      path: `/holidayCalendars`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags HolidayCalendars
   * @name HolidayCalendarsPut
   * @summary Updates the passed holiday calendar model.
   * @request PUT:/holidayCalendars/{id}
   */
  holidayCalendarsPut = (
    id: number,
    data: HolidayCalendarModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<HolidayCalendarModelDto, any>({
      path: `/holidayCalendars/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags HolidayCalendars
   * @name HolidayCalendarsDelete
   * @summary Delete the Holiday calendar for the specified Id.
   * @request DELETE:/holidayCalendars/{id}
   */
  holidayCalendarsDelete = (id: number, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/holidayCalendars/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
}
